import styled, { ThemeProps } from '@themes/theme'
import { css } from '@emotion/core'
import { TxtLimit2 } from '@styles/base.style'

const eventBtnH = '21px'
export const ClubEventWrap = styled.div`
  z-index: 1;
  top: -1px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  height: ${eventBtnH};
  box-sizing: border-box;
  text-align: left;
  .club-event-btn {
    padding: 0 7px;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // position: relative;
    // width: auto;
    // height: ${eventBtnH};
    // line-height: ${eventBtnH};
    // margin-left: 6px;
    // padding: 0 9px;
    // border-radius: 50px;
    // text-align: center;
    // background: ${props => props.theme.color.yellow};
    img {
      width: auto;
      height: 20px;
    }
  }
`

// 클럽 이벤트 모달
export const ClubEventStyle = (props: ThemeProps) => css`
  position: fixed;
  top: 0;
  left: 0;
  text-align: center;
  line-height: 3rem;
  overflow: hidden;
  overflow-y: auto;
  overscroll-behavior: none;
`
export const ClubEventModalWrap = styled.div`
  ${ClubEventStyle};
  .club-event-box {
    position:relative;
    width: 100%;
    padding: 0 10%;
    margin: 58px auto 100px;
    .club-event-txt {
      font-size: ${props => props.theme.font.title};
      &.club-detail-btn {
        display: block;
        width: auto;
        margin: 38px auto 0;
        line-height: 24px;
        height: 24px;
        > svg {
          width: 12px;
          height: auto;
          transform: rotate(-90deg) translateX(2px);
        }
      }
    }
    .cls-btn {
      position: absolute;
      top: 0;
      right: 30px;
      border-radius: 50%;
      width: 32px;
      height: 32px;
      min-width: 0;
      background: none;
      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 22px;
        height: 22px;
        background: ${props => props.theme.color.themeTxt};
        border-radius: 50%;
      }
      .arrow {
        position: absolute;
        top: 50%;
        left: 50%;
        display: block;
        width: 10px;
        height: 1px;
        background: ${props => props.theme.color.btn};
        border-radius: 50px;
        &.arrow-1 {
          transform: translate(-50%,-50%) rotate(135deg);
        }
        &.arrow-2 {
          transform: translate(-50%,-50%) rotate(-135deg);
        }
      }
    }
    &.pc {
      margin: 90px auto 100px;
      width: 350px;
      padding: 0 0 20px;
    }
  }
  .club-event-list {
    display: flex;
    flex-flow: column;
    align-items: center;
    margin-top: 16px;
    &:first-of-type { // 승부사이벤트 타이틀 관련 스타일
      margin-top: 12px;
    }
    &--item {
      margin-bottom: 6px;
      &:nth-of-type(1) {
        transition: transform .18s cubic-bezier(.04,.85,.41,1.16);
        transition-delay: .02s;
      }
      &:nth-of-type(2) {
        transition: transform .26s cubic-bezier(.04,.85,.41,1.16);
        transition-delay: .04s;
      }
      &:nth-of-type(3) {
        transition: transform .34s cubic-bezier(.04,.85,.41,1.16);
        transition-delay: .065s;
      }
      &:nth-of-type(4) {
        transition: transform .42s cubic-bezier(.04,.85,.41,1.16);
        transition-delay: .09s;
      }
      .club-event-list-btn {
        text-align: left;
        background: none;
        border-radius: 10px;
        overflow: hidden;
        .new-badge-img {
          position: absolute;
          top: 0;
          left: 0;
          transform: translate(145%, 80%);
          width: 17%;
          height: auto;
        }
      }
      &--txt {
        position: absolute;
        top: 62%;
        left: 20px;
        transform: translateY(-50%);
        ${TxtLimit2};
        height: 36px;
        max-height: 36px;
        line-height: 1.8rem;
        max-width: calc(100% - 97px);
        font-size: ${props => props.theme.font.large};
        color: ${props => props.theme.color.themeTxt};
        text-shadow: 0 1px 2px rgba(0, 19, 64, .35);
      }
      &--img {
        width: 100%;
        height: auto;
      }
      &:not(.list-1):not(.list-2):not(.list-3):not(.list-4)  {
        display: none;
      }
      &.adv-event {
        .club-event-list-btn {
          padding: 5px 0 6px;
          background: #2A323F;
        }
      }
    }
  }
  &.hide {
    z-index: 0;
    width: 0;
    height: 0;
    opacity: 0;
    .modal-bg {
      opacity: 0;
      width: 0;
      height: 0;
      transition: opacity .2s;
    }
    .club-event-list {
      opacity: 0;
      &--item {
        opacity: 0;
        width: 0;
        height: 0;
        overflow: hidden;
        transform: scale(.1);
      }
    }
  }
  &.show {
    z-index: 102; /* 메세지 알림 모달보다 앞에 떠야함 */
    width: 100vw;
    height: 100vh;
    .modal-bg {
      width: 100vw;
      height: 100vh;
      transition: opacity .3s;
    }
    .club-event-list {
      opacity: 1;
      transition: opacity .3s;
      &--item {
        opacity: 1;
        width: 100%;
        transform: scale(1);
      }
    }
  }
`

const FlexStyle = css`
  display: flex;
  align-items: center;
`
export const ClubNoticeContainer = styled.div`
  position: relative;
  ${FlexStyle};
  justify-content: space-between;
  width: 100%;
  height: 42px;
  margin-bottom: 6px;
  padding: 0 14px;
  line-height: 3.7rem;
  margin-top: 6px;
  .club-notice-wrap {
    ${FlexStyle};
  }
  .btn-wrap {
    ${FlexStyle};
    flex: 1;
    justify-content: flex-end;
  }
  /* 게스트 모드 */
  &.guest {
    height: 10px;
    margin-top: 0;
  }
`
export const ClubNames = styled.button`
  position: relative;
  margin-right: 2px;
  padding: 0;
  font-size: ${props => props.theme.font.large};
  background: none;
  border: none;
  svg {
    position:relative;
    top: 1px;
    width: 14px;
  }
  .club-info-badge {
    position: absolute;
    top: -4px;
    left: -5px;
    .am-badge-dot {
      width: 6px;
      height: 6px;
      background: ${props => props.theme.color.red};
    }
  }
`
